import {
  GOOGLE_PMAX_VIDEO_MAX_DURATION_SECONDS,
  GOOGLE_PMAX_VIDEO_MIN_DURATION_SECONDS,
  YOUTUBE,
  YOUTUBE_PRIVACY_STATUS,
} from "./constants";
import { normalizeYoutubeWatchUrl } from "./string";
import { getVideoDurationAsync, isVideoDurationInRange } from "./videoDuration";

export const validateGooglePmaxVideoDuration = async ({ url }) => {
  const duration = await getVideoDurationAsync({ url });

  return isVideoDurationInRange({
    duration,
    minSeconds: GOOGLE_PMAX_VIDEO_MIN_DURATION_SECONDS,
    maxSeconds: GOOGLE_PMAX_VIDEO_MAX_DURATION_SECONDS,
  });
};

export const buildYoutubeOrganicUploadPayload = ({
  videoUrl,
  language,
  account,
  title,
}) => ({
  urls: [videoUrl],
  language,
  platforms: [YOUTUBE],
  platformsData: {
    youtube: {
      integrationID: account?.integrationID || account?.id,
      title: title.trim(),
      privacyStatus: YOUTUBE_PRIVACY_STATUS.public,
      notifySubscribers: false,
      madeForKids: false,
    },
  },
});

export const extractYoutubeUrlFromUploadResponse = (response) => {
  const youtubeResult = (response?.results || []).find((entry) => {
    if (!entry?.ok || typeof entry?.url !== "string" || !entry.url) {
      return false;
    }

    return String(entry.platform || "").toLowerCase() === YOUTUBE;
  });

  if (!youtubeResult?.url) {
    return null;
  }

  return normalizeYoutubeWatchUrl({ url: youtubeResult.url });
};

export const appendYoutubeVideoUrl = ({
  currentUrls = [],
  youtubeUrl,
  maxVideos,
}) => {
  const trimmedUrl = youtubeUrl?.trim();
  if (!trimmedUrl) {
    return currentUrls;
  }

  const videos = (currentUrls || []).filter(Boolean);
  if (videos.length >= maxVideos) {
    return videos;
  }

  const isDuplicate = videos.some(
    (videoUrl) => videoUrl.trim().toLowerCase() === trimmedUrl.toLowerCase()
  );

  if (isDuplicate) {
    return videos;
  }

  return [...videos, trimmedUrl];
};
